// extracted by mini-css-extract-plugin
export default {"Title":"Profile_Title__CLd+0","ProfileInformation":"Profile_ProfileInformation__C5rTv","UserName":"Profile_UserName__oyitU"};